import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getVisitorId() {
  let id = localStorage.getItem("negosino_visitor_id");
  if (!id) {
    id = (crypto?.randomUUID && crypto.randomUUID()) || `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("negosino_visitor_id", id);
  }
  return id;
}

function getSessionId() {
  const KEY = "negosino_session_id";
  const TS_KEY = "negosino_session_ts";
  const now = Date.now();
  const last = parseInt(sessionStorage.getItem(TS_KEY) || "0", 10);
  let sid = sessionStorage.getItem(KEY);
  // 30 min inactivity resets session
  if (!sid || now - last > 30 * 60 * 1000) {
    sid = `s_${now}_${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(KEY, sid);
  }
  sessionStorage.setItem(TS_KEY, String(now));
  return sid;
}

function detectMobile() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * Fires an anonymous page-view event on every route change (client-side).
 * Skips the /admin area so admin browsing doesn't pollute stats.
 */
export default function AnalyticsTracker() {
  const loc = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = loc.pathname;
    if (path.startsWith("/admin")) return;
    if (path === lastPath.current) return;
    lastPath.current = path;

    // Fire-and-forget; never block UI
    const payload = {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      path,
      referrer: document.referrer || null,
      lang: (document.documentElement.lang || "").slice(0, 8),
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
      is_mobile: detectMobile(),
    };
    api.post("/analytics/track", payload).catch(() => {});
  }, [loc.pathname]);

  return null;
}
